import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  onExpire?: () => void;
}
export function CountdownTimer({
  initialMinutes = 10,
  initialSeconds = 43,
  className = '',
  onExpire
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) {
      if (onExpire) onExpire();
      return;
    }
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft, onExpire]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  if (timeLeft <= 0) {
    return <span className={`font-bold ${className}`} data-id="element-37">¡Tiempo agotado!</span>;
  }
  return <span className={`font-bold tabular-nums tracking-wider ${className}`} data-id="element-38">
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>;
}